import React, { useState, useMemo } from 'react';
import classnames from 'classnames';

import { FILTER_DELIVERY_METHODS } from 'dpl/constants/query_params';
import useSearchQueryFilter from 'dpl/breeder_search_results/hooks/useSearchQueryFilter';
import { deliveryMethodOptionsResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import TransportationModal from 'dpl/breeder_search_results/components/TransportationModal';
import InputCard from 'dpl/common/design_system/InputCard';
import { TRANSPORT_KEYS } from 'dpl/breeder_search_results/utils/constants';
import Banner from 'dpl/common/design_system/Banner';

export default function TransportationFilter() {
  const { searchQueryFilterValues, toggleFilter } = useSearchQueryFilter(
    FILTER_DELIVERY_METHODS
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    value: { data: deliveryMethods }
  } = useResourceQuery(deliveryMethodOptionsResourceDefinition(true));

  const sortedDeliveryMethods = useMemo(() => {
    return deliveryMethods
      .filter(dm => dm.key !== 'pickup')
      .sort((dm1, dm2) => dm1.position - dm2.position);
  }, [deliveryMethods]);

  function handleOpenModalClick(e) {
    e.stopPropagation();
    setIsModalOpen(true);
  }

  function handleCloseModalClick() {
    setIsModalOpen(false);
  }

  function isSelected(opt) {
    return searchQueryFilterValues.includes(Number(opt.id));
  }

  const transportKeyToSvg = {
    [TRANSPORT_KEYS.GROUND_TRANSPORT]: 'fetch-delivery-truck',
    [TRANSPORT_KEYS.AIR_CARGO]: 'fetch-airplane',
    [TRANSPORT_KEYS.FLIGHT_NANNY]: 'head-pat',
    [TRANSPORT_KEYS.MEET_HALFWAY]: 'fetch-location'
  };

  return (
    <>
      <p className="mb4 font-16 fw-medium md:font-18 md:font-serif">
        Drop-off options
      </p>
      <div className="SearchResultFiltersTransportationFilter flex flex-wrap mb4">
        {sortedDeliveryMethods.map(opt => (
          <div
            key={opt.key}
            className={classnames(
              'SearchResultFiltersTransportationFilter__option'
            )}
          >
            <InputCard
              className={classnames('ba ph4 pv4', {
                'b--default': !isSelected(opt),
                'b--midnight': isSelected(opt)
              })}
              type="checkbox"
              icon={{
                className: 'bg-pale-blue midnight ph2 pv2',
                name: transportKeyToSvg[opt.key],
                size: '20'
              }}
              inputProps={{
                name: `${FILTER_DELIVERY_METHODS}_${opt.id}`,
                value: opt.id,
                onChange: e => toggleFilter(Number(e.target.value))
              }}
            >
              <div className="font-16 lh-1 mt6">{opt.name}</div>
            </InputCard>
          </div>
        ))}
      </div>

      <Banner
        color="gray"
        iconName="fetch-info-24"
        type="horizontal"
        className="font-16 items-center"
      >
        <button
          onClick={handleOpenModalClick}
          className="midnight underline"
          type="button"
        >
          Learn more
        </button>{' '}
        about our safe drop-off options.
      </Banner>

      {isModalOpen && (
        <TransportationModal onCloseClick={handleCloseModalClick} />
      )}
    </>
  );
}
